
import { useState } from 'react';

export default function RobotsPage() {
  const [copied, setCopied] = useState(false);
  
  const baseUrl = window.location.origin;
  const sitemapUrl = `${baseUrl}/sitemap.xml`;
  
  const robotsContent = `# robots.txt for ${baseUrl}
# Generated by Kaonavi Dictionary

User-agent: *
Allow: /

# Sitemap
Sitemap: ${sitemapUrl}

# Crawl-delay (optional)
Crawl-delay: 1

# Disallow admin pages
Disallow: /admin
Disallow: /admin/

# Allow search engines to index all public content
Allow: /blog/
Allow: /document
Allow: /estimate
Allow: /contact
`;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(robotsContent);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Copy failed:', error);
    }
  };

  const downloadTxt = () => {
    const blob = new Blob([robotsContent], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'robots.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">robots.txt</h1>
              <p className="text-sm text-gray-500 mt-1">
                検索エンジンのクローラー向け設定ファイル
              </p>
            </div>
            <div className="flex gap-3">
              <button
                onClick={copyToClipboard}
                className="flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className={`ri-${copied ? 'check' : 'file-copy'}-line`}></i>
                {copied ? 'コピー完了' : 'コピー'}
              </button>
              <button
                onClick={downloadTxt}
                className="flex items-center gap-2 px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-line"></i>
                ダウンロード
              </button>
            </div>
          </div>

          {/* 設定内容 */}
          <div className="mb-6">
            <h2 className="text-lg font-semibold text-gray-800 mb-3">設定内容</h2>
            <div className="bg-gray-900 rounded-lg p-4 overflow-x-auto">
              <pre className="text-sm text-green-400 font-mono whitespace-pre">{robotsContent}</pre>
            </div>
          </div>

          {/* 設定項目の説明 */}
          <div className="mb-6">
            <h2 className="text-lg font-semibold text-gray-800 mb-3">設定項目の説明</h2>
            <div className="border rounded-lg overflow-hidden">
              <table className="w-full text-sm">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="text-left px-4 py-3 font-medium text-gray-600 w-40">ディレクティブ</th>
                    <th className="text-left px-4 py-3 font-medium text-gray-600">説明</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-mono text-orange-600">User-agent: *</td>
                    <td className="px-4 py-3 text-gray-600">すべての検索エンジンボットに適用</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-mono text-orange-600">Allow: /</td>
                    <td className="px-4 py-3 text-gray-600">サイト全体のクロールを許可</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-mono text-orange-600">Sitemap:</td>
                    <td className="px-4 py-3 text-gray-600">サイトマップのURLを指定</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-mono text-orange-600">Crawl-delay:</td>
                    <td className="px-4 py-3 text-gray-600">クロール間隔（秒）を指定</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-mono text-orange-600">Disallow:</td>
                    <td className="px-4 py-3 text-gray-600">クロールを禁止するパスを指定</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* サイトマップURL */}
          <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-6">
            <div className="flex items-start gap-3">
              <i className="ri-map-pin-line text-orange-500 text-xl mt-0.5"></i>
              <div>
                <p className="font-medium text-gray-800">登録されたサイトマップURL</p>
                <a 
                  href="/sitemap" 
                  className="text-orange-600 hover:text-orange-700 hover:underline break-all"
                >
                  {sitemapUrl}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* 使い方ガイド */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            <i className="ri-lightbulb-line text-orange-500 mr-2"></i>
            robots.txtの設置方法
          </h2>
          <div className="space-y-4 text-sm text-gray-600">
            <div className="flex gap-3">
              <span className="flex-shrink-0 w-6 h-6 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center font-medium">1</span>
              <div>
                <p className="font-medium text-gray-800">ファイルをダウンロード</p>
                <p>上のダウンロードボタンからrobots.txtをダウンロードします。</p>
              </div>
            </div>
            <div className="flex gap-3">
              <span className="flex-shrink-0 w-6 h-6 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center font-medium">2</span>
              <div>
                <p className="font-medium text-gray-800">サーバーのルートに配置</p>
                <p>ダウンロードしたファイルをWebサイトのルートディレクトリ（例: public_html/）に配置します。</p>
              </div>
            </div>
            <div className="flex gap-3">
              <span className="flex-shrink-0 w-6 h-6 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center font-medium">3</span>
              <div>
                <p className="font-medium text-gray-800">動作確認</p>
                <p>ブラウザで <code className="bg-gray-100 px-1.5 py-0.5 rounded text-orange-600">{baseUrl}/robots.txt</code> にアクセスして確認します。</p>
              </div>
            </div>
            <div className="flex gap-3">
              <span className="flex-shrink-0 w-6 h-6 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center font-medium">4</span>
              <div>
                <p className="font-medium text-gray-800">Google Search Consoleで確認</p>
                <p>Search Consoleの「robots.txtテスター」でファイルが正しく認識されているか確認します。</p>
              </div>
            </div>
          </div>

          <div className="mt-6 p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-600">
              <i className="ri-information-line text-gray-500 mr-1"></i>
              <strong>注意:</strong> robots.txtとsitemap.xmlは両方ともサーバーのルートディレクトリに配置してください。
              サイトマップは<a href="/sitemap" className="text-orange-600 hover:underline">こちら</a>からダウンロードできます。
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
